import React from 'react'

export const About = () => {
  return (
    <div className='about-section'>
        <h2>About Us</h2>
        <p>
        Welcome to TRADEMATE - Your one-stop destination for the latest tech and lifestyle products! Shop with ease and confidence, and enjoy high-quality products at affordable prices.
        </p>
    </div>
  )
}
